module.exports = __webpack_public_path__ + "static/img/main_name.75d26a52.png";